module.exports = __webpack_public_path__ + "img/publication-2.a8b8e4b9.svg";